export const FETCH_ALL_GOALS = 'FETCH_ALL_GOALS';
export const CREATE_GOAL = 'CREATE_GOAL';
export const GET_GOAL = 'GET_GOAL';
export const PATCH_GOAL = 'PATCH_GOAL';
export const UPDATE_GOAL = 'UPDATE_GOAL';
export const DELETE_GOAL = 'DELETE_GOAL';
export const FETCH_GROUP_GOALS = 'FETCH_GROUP_GOALS';
export const FETCH_MY_GOALS = 'FETCH_MY_GOALS';